import React, { useState } from 'react';
import CardProfile from '../../../components/Profile/Card/';
import { showLoading, hideLoading } from '../../../store/actions/LoadingActions';

//import AboutForm from './Forms';
import { Formik } from 'formik';
import { validationCost } from '../../../utils/validations';
import ButtonBase from '../../../components/Buttons/ButtonBase';
import AuthButton from '../../../components/Buttons/AuthButton';
import ButtonAction from '../../../components/Buttons/ButtonAction';
import OptionsButton from '../../../components/Buttons/OptionsButton';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/styles';
import './Cost.scss';
import { addCost } from '../../../store/actions/UserAction';
import CostForm from '../../../components/Profile/CostForm';
import Snackbar from '../../../components/Snackbar';
import TrophieModal from '../../../components/Modal/TrophieModal';
import { isMobile } from 'react-device-detect';

const useStyles = makeStyles({
  cardHeader: {
    display: 'block',
    paddingBottom: 0,
    fontSize: 22,
    '&:after': {
      content: '""',
      display: 'block',
      margin: '0 auto',
      width: '100%',
      paddingTop: '8px',
      borderBottom: '1px solid #c1c1c1',
    },
  },
});

const Cost = (props) => {
  const {
    addCost,
    uid,
    cost,
    authClient,
    evento,
    showLoading,
    hideLoading,
    role,
    trophie,
    membershipType
  } = props

  const [feedbackMessage, setFeedbackMessage] = useState({
    open: false,
    message: '',
    variant: 'success'
  });

  const [openTrophieModal, setOpenTrophieModal] = useState(false);

  const handleOpenTrophieModal = () => {
    setOpenTrophieModal(true);
  };

  const handleCloseTrophieModal = () => {
    setOpenTrophieModal(false);
  };

  const handleCloseFeedbackMessage = () => {
    setFeedbackMessage({
      open: false,
      message: '',
      variant: 'success'
    });
  };

  const handleSubmit = (values, { setSubmitting, setFieldError }) => {
    setSubmitting(false);
    showLoading()
    const arrayValues = Object.values(values)
    const boolValues = arrayValues.every(elem => elem)

    addCost(uid, values, boolValues)
      .then(res => {
        if (boolValues === false || trophie) {
          setFeedbackMessage({
            open: true,
            message: 'Tus cambios se han guardado con éxito',
            variant: 'success'
          });
        }
        if (boolValues === true && !trophie) {
          handleOpenTrophieModal()
        }
      }).catch(error => { })
    setTimeout(() => {
      hideLoading()
    }, 2000);

  };

  const resetTab = () => {

  }



  let formValuesCost = {}

  if (cost) {
    formValuesCost = {
      consultingCost: cost.consultingCost,
      costRange: cost.costRange,
      typesOfRates: cost.typesOfRates,
    }
  }

  const classes = useStyles();

  return (
    <div className={'cost'}>

      <CardProfile
        title={'Costo de servicios'}
        subTitle={
          role === "lawyer" ? 
          'Puedes colocar el precio de tus servicios por hora o asesoría.' : 
          'Puedes colocar el precio aproximado de los servicios del despacho.'
        }
        awardIcon
        status={authClient && authClient.awardAditional.cost ? authClient.awardAditional.cost : false}
      >
        <div className="container">
          <Formik
            initialValues={formValuesCost}
            validationSchema={validationCost}
            onSubmit={handleSubmit}
            render={props => <CostForm evento={resetTab} {...props} />}
          />
        </div>
      </CardProfile>

      <TrophieModal
        open={openTrophieModal}
        trophieValidation={trophie}
        topic="award-profile"
        handleClose={handleCloseTrophieModal}
        title='Costo de servicios'
        subtitle={['¡Felicidades', <br />, 'haz obtenido este logro!']}
        footer='Es importante informarle a los clientes sobre los costos de tus asesorías'
      />

      <Snackbar
        open={feedbackMessage.open}
        message={feedbackMessage.message}
        variant={feedbackMessage.variant}
        handleClose={handleCloseFeedbackMessage}
        vertical="top"
        horizontal="right"
        snackbarTop={isMobile ? '70px' : '80px'}
      />
    </div>
  );
};

const mapStateToProps = state => ({
  role: state.authClient.role,
  uid: state.authClient.uid,
  cost: state.authClient.cost,
  authClient: state.authClient,
  trophie: state.authClient.awardAditional.cost,
  membershipType: state.authClient.membership.type,
});

const mapDispatchToProps = dispatch => ({
  addCost: (uid, values, boolValues) => dispatch(addCost(uid, values, boolValues)),
  showLoading: () => dispatch(showLoading()),
  hideLoading: () => dispatch(hideLoading()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Cost);



